import { render, staticRenderFns } from "./PdpStockStatus.vue?vue&type=template&id=ec0f5330&"
import script from "./PdpStockStatus.vue?vue&type=script&lang=js&"
export * from "./PdpStockStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports